import React from "react";
import { useMediaQuery } from "./hooks/useMediaQuery";

const tagsGuide = {
  "ترکی دیلینده": "TURKISH_NATIVE",
  "گزارش ترکی": "TURKISH_REPORT",
  "پخش زنده": "LIVE_STREAM",
  بزودی: "COMING_SOON",
  "آنلاین باخیش": "ONLINE_CINEMA",
  آرشیو: "ARCHIVE",
};

const tagImageGuide = {
  TURKISH_NATIVE: {
    large: "/tags/turkish-native-large.svg",
    small: "/tags/turkish-native-small.svg",
    sportClassName: "w-[40%] bg-[#B21F1F] shadow-[-1px 1px 7px #121212]",
    animationClassName: "w-[30%] bg-none shadow-none",
    className: "w-[50%] bg-[#B21F1F] shadow-[-1px 1px 7px #121212] border-1",
  },
  TURKISH_REPORT: {
    large: "/tags/gozaresh-large.svg",
    small: null,
    sportWidth: 110,
    animationWidth: 100,
    width: 110,
    sportClassName: "bg-none shadow-none",
    animationClassName: "bg-none shadow-none",
    className: "bg-none shadow-none",
  },
  LIVE_STREAM: {
    large: "/tags/live-stream-large.svg",
    small: null,
    sportClassName: "w-[40%] bg-none shadow-none",
    animationClassName: "w-[30%] bg-none shadow-none",
    className: "w-[150px] bg-none shadow-none",
  },
  COMING_SOON: {
    large: "/tags/coming-soon-large.svg",
    small: null,
    sportClassName: "w-[40%] bg-[#B21F1F] shadow-[-1px 1px 7px #121212]",
    animationClassName: "w-[30%] bg-none shadow-none",
    className: "w-[40%] bg-[#B21F1F] shadow-[-1px 1px 7px #121212]",
  },
  ONLINE_CINEMA: {
    large: "/tags/online-cinema-large.svg",
    small: "/tags/online-cinema-small.svg",
    sportClassName: "w-[40%] shadow-[-1px 1px 7px #121212]",
    animationClassName: "w-[30%] bg-none shadow-none",
    className: "w-[40%] bg-[#B21F1F] shadow-[-1px 1px 7px #121212]",
  },
  ARCHIVE: {
    large: "/tags/archive-large.svg",
    small: null,
    sportClassName:
      "w-[40%] max-w-[120px] bg-[#B21F1F] shadow-[-1px 1px 7px #121212]",
    animationClassName: "w-[30%] bg-none shadow-none",
    className: "w-[140px]  bg-[#B21F1F]",
  },
};

const ContentTag = ({ label, type, relative }) => {
  const isMD = useMediaQuery("(min-width: 768px)");
  const tagCode = tagsGuide[label];

  if (!tagCode) return null;

  const tagImage = tagImageGuide[tagCode];

  const tagImageSrc =
    !isMD && tagImage?.small !== null ? tagImage?.small : tagImage?.large;

  return (
    <div
      className={
        "legacy-content-tag" + (relative ? " legacy-content-tag-relative" : "")
      }
    >
      {type === "sport" ? (
        <img
          src={tagImageSrc}
          alt={label}
          width={tagImage.sportWidth}
          className={"legacy-content-tag-image " + tagImage.sportClassName}
        />
      ) : type === "animation" ? (
        <img
          src={tagImageSrc}
          alt={label}
          width={tagImage.animationWidth}
          className={"legacy-content-tag-image " + tagImage.animationClassName}
        />
      ) : (
        <img
          src={tagImageSrc}
          alt={label}
          width={tagImage.width || (tagCode === "LIVE_STREAM" ? 220 : 140)}
          className={"legacy-content-tag-image " + tagImage.className}
        />
      )}
    </div>
  );
};

export default ContentTag;
